import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => {
    const headerHeight = theme.old.sizes.header;
    const { isMobile } = theme.old.breakpoints;

    return css`
      margin-top: ${`-${headerHeight}`};

      ${isMobile} {
        margin-top: 0;
      }
    `
  }}
`
